import React from 'react';
import { MOCK_UP } from '../../../propTypes';
import { Composition } from '../Composition';
import { wideMockUp, squareMockUp } from './config';
import './index.scss';

export const LaptopMockUp = ({ variation, className, isSquare }) => {
    const mockup = isSquare ? squareMockUp : wideMockUp;

    return (
        <Composition
            className={className}
            variation={variation}
            layers={mockup.layers}
            aspectRatio={mockup.aspectRatio}
            transparentBackground={true}
        />
    );
};

LaptopMockUp.propTypes = MOCK_UP;
